import { useTranslation } from 'react-i18next'

import { format } from 'date-fns'

import { Audience } from 'app/audiences/types'
import { Connection } from 'app/common/presentation'
import { User } from 'app/user/types'

import { Section } from 'components'

import styles from './Details.module.scss'

interface DetailsProps {
  audience: Audience
  className?: string
  createdBy: User | null
}

const Details = ({ audience, className, createdBy }: DetailsProps) => {
  const { t } = useTranslation('audiences')

  return (
    <div className={[styles.details, className].join(' ')}>
      <Section name={t('details.details.title')} />
      <div className={styles.info}>
        <div className={styles.row}>
          <div className={styles.property}>{t('details.details.dateCreated')}</div>
          <div className={styles.value}>
            {audience.created ? format(audience.created, 'MMM dd, HH:mm aa') : '-'}
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.property}>{t('details.details.createdBy')}</div>
          <div className={styles.value}>{createdBy?.firstName ?? '-'}</div>
        </div>
        <div className={styles.row}>
          <div className={styles.property}>{t('details.details.audienceType')}</div>
          <div className={styles.value}>{t(`type.${audience.config.purpose}`)}</div>
        </div>
        <div className={styles.row}>
          <div className={styles.property}>{t('details.details.connection')}</div>
          <div className={styles.value}>
            <Connection
              className={styles.connection}
              iconSize={14}
              connection={audience.connection}
            />
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.property}>{t('details.details.connectedAdAccount')}</div>
          <div className={styles.value}>
            {audience.account?.name ?? audience.account?.id ?? '-'}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Details
